import { Button, ButtonProps } from '@mantine/core';
import { RouteParams } from 'atomic-router';
import { Link, LinkProps } from 'atomic-router-react';
import clsx from 'clsx';
import cls from './nav-list.module.scss';

type NavListItemProps<TParams extends RouteParams> = {
	activeParam?: boolean;
	active?: boolean;
} & LinkProps<TParams> &
	ButtonProps;

export const NavListItem = <TParams extends RouteParams>({
	children,
	active = false,
	activeParam = true,
	...props
}: NavListItemProps<TParams>) => (
	<Button
		variant='ghost'
		component={Link<TParams>}
		activeClassName={cls.navListItemActive}
		classNames={{
			root: clsx(cls.navListItemRoot, { [cls.navListItemActive]: active }),
			inner: cls.navListItemInner,
			label: cls.navListItemLabel,
		}}
		data-active-param={activeParam || undefined}
		replace={activeParam}
		{...props}
	>
		{children}
	</Button>
);
